module.exports = __webpack_public_path__ + "static/designing-a-workplace-b8d4aec69a5a357f3a70e9be5680d226.png";